import { library } from '@fortawesome/fontawesome-svg-core';

// FontAwesome icons
import { faTwitter, faFacebook, faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';

library.add(
  faTwitter,
  faFacebook,
  faGithub,
  faLinkedin,
);